@if (previewFileId) {
  <div class="modal modal-fullscreen modal-lg"
    tabindex="-1" role="dialog" [id]="previewFileId">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ filePreviewTitle }}</h5>
          <button
            mat-raised-button
            mat-stroked-button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            (click)="closeFilePreview()">
            Close
          </button>
        </div>
        <div>
          <app-material-pdf-viewer [fileId]="previewFileId"/>
        </div>
      </div>
    </div>
  </div>
}
